import React from 'react'

import Subtitle from '../../../components/Subtitle'
import withFetch from '../../../infrastructure/withFetch'
import KeyMetricsWidget from '../components/KeyMetricsWidget'
import KeyMetricsVisits from './KeyMetricsVisits'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/visits/get-by-date/${eventId}?startDate=${startDate}&endDate=${endDate}`

const Chart = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry, event }) => {
        return (
            <KeyMetricsWidget data={data} status={status} retry={retry}>
                <KeyMetricsVisits data={data} event={event} />
            </KeyMetricsWidget>
        )
    },
)

const tooltip = (
    <div>
        <p>
            Click on each option (Unique Browsers, Page Views) to change graph.
        </p>
        <p>Hover mouse over chart plot line to see figure for each day.</p>
        <p>
            Small number under Unique Browsers and Page Views is for figures
            today (since Midnight, venue time).
        </p>
        <p>
            Note: Customers who have already purchased tickets to this event are
            included in this data.
        </p>
        <p>
            Page Views is the total number of event pages viewed each day; where
            a single Page View is an instance of a page being loaded (or
            reloaded) in a web browser.
        </p>
        <ul>
            <li>
                A single customer making a purchase views multiple pages as part
                of that purchase, with each page counted.
            </li>
            <li>
                If a visitor views the event page in the morning and then comes
                back and views the event page again later in the day using the
                same web browser, they will be counted for each time they viewed
                the page.
            </li>
            <li>
                A visitor who views an event page on their mobile and then logs
                in to their desktop computer to view the event page will be
                counted separately.
            </li>
            <li>
                If a customer opens the page prior to an on-sale and refreshes
                the event page multiple times waiting for the on-sale time, they
                will be counted each time the page loads.
            </li>
        </ul>
        <p>
            Unique Browsers is the number of individual visitors who have
            visited your event page each day using the same web browser,
            regardless of how many pages they viewed.
        </p>
        <ul>
            <li>
                A single customer viewing multiple pages during a purchase is
                counted only once.
            </li>
            <li>
                If a visitor views the event page in the morning and then comes
                back and views the event page again later in the day using the
                same web browser, they will be counted only once.
            </li>
            <li>
                A visitor who views an event page on their mobile and then logs
                in to their desktop computer to view the event page will be
                counted separately (unique browsers is per web browser used).
            </li>
            <li>
                If a customer opens the page prior to an on-sale and refreshes
                the event page multiple times waiting for the on-sale time, they
                will be counted once only.
            </li>
        </ul>
    </div>
)

const GetVisitsWidget = ({ eventId, startDate, endDate }) => (
    <div>
        <Subtitle title="Visitor Browsing Trend" tooltip={tooltip} />
        <Chart eventId={eventId} startDate={startDate} endDate={endDate} />
    </div>
)

export default GetVisitsWidget
